module.exports = __webpack_public_path__ + "media/images/flags/16/Paraguay-96a600c3f3d15c8630d055f7f56519bd.png";